import React from 'react';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '16px 20px 20px 20px',
        backgroundColor: '#ffffff'
    },
    alert: {
        fontSize: 13.5,
        lineHeight: 1.55,
        borderRadius: 8,
        '& .MuiAlert-icon': {
            fontSize: 22
        },
        '& .MuiAlert-message': {
            padding: '2px 0',
            color: '#1e293b'
        }
    },
    actionsWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 12,
        marginTop: 18,
        paddingTop: 14,
        borderTop: '1px solid #f1f5f9'
    },
    cancelBtn: {
        minWidth: 90,
        height: 36,
        padding: '0 18px',
        borderRadius: 6,
        fontSize: 12.5,
        fontWeight: 600,
        textTransform: 'uppercase',
        color: '#475569',
        borderColor: '#cbd5e1',
        backgroundColor: '#ffffff',
        '&:hover': {
            backgroundColor: '#f8fafc',
            borderColor: '#94a3b8'
        }
    },
    confirmBtn: {
        minWidth: 100,
        height: 36,
        padding: '0 20px',
        borderRadius: 6,
        fontSize: 12.5,
        fontWeight: 600,
        textTransform: 'uppercase',
        color: '#ffffff',
        backgroundColor: '#f50057',
        boxShadow: '0 1px 3px rgba(245, 0, 87, 0.25)',
        '&:hover': {
            backgroundColor: '#c51162',
            boxShadow: '0 2px 4px rgba(245, 0, 87, 0.35)'
        }
    }
}));

export default function ConfirmationModal(props) {
    const classes = useStyles();
    const isLoader = props.isBtnLoader || props.btnLoader || props.loader || false;
    const severity = props.severity || 'warning';

    return (
        <div className={classes.root}>
            <Alert severity={severity} className={classes.alert}>
                {props.message}
                {props.children}
            </Alert>

            <div className={classes.actionsWrapper}>
                {props.handleCancel && (
                    <Button
                        variant="outlined"
                        onClick={props.handleCancel}
                        disabled={isLoader}
                        className={classes.cancelBtn}
                    >
                        {props.cancelLabel || 'Cancel'}
                    </Button>
                )}
                {props.handleSubmit && (
                    <Button
                        variant="contained"
                        onClick={!isLoader ? props.handleSubmit : undefined}
                        disabled={isLoader}
                        className={classes.confirmBtn}
                    >
                        {isLoader ? (
                            <CircularProgress size={18} style={{ color: '#ffffff' }} />
                        ) : (
                            props.label || 'Confirm'
                        )}
                    </Button>
                )}
            </div>
        </div>
    );
}
